import React from "react";
import {
	Box,
	Paper,
	TextField,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Button,
	Typography
} from "@mui/material";
import {
	AuditLogFilter,
	EntityType,
	OperationType
} from "../../models/auditLog";

const operationOptions: OperationType[] = ["CREATE", "UPDATE", "DELETE"];
const entityTypeOptions: Array<EntityType | "All"> = [
	"All",
	"Invoice",
	"Item",
	"Return"
];

interface AuditLogFiltersProps {
	filter: AuditLogFilter;
	onFilterChange: (filter: AuditLogFilter) => void;
	onApply: () => void;
	onReset: () => void;
}

export const AuditLogFilters: React.FC<AuditLogFiltersProps> = ({
	filter,
	onFilterChange,
	onApply,
	onReset
}) => {
	return (
		<Paper elevation={3} sx={{ p: 3, mb: 3 }}>
			<Typography variant="h6" gutterBottom>
				Audit Filters
			</Typography>
			<Box
				sx={{
					display: "grid",
					gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
					gap: 2
				}}
			>
				<TextField
					label="Start Date"
					type="date"
					value={filter.startDate}
					onChange={(event) =>
						onFilterChange({
							...filter,
							startDate: event.target.value
						})
					}
					InputLabelProps={{ shrink: true }}
				/>
				<TextField
					label="End Date"
					type="date"
					value={filter.endDate}
					onChange={(event) =>
						onFilterChange({
							...filter,
							endDate: event.target.value
						})
					}
					InputLabelProps={{ shrink: true }}
				/>
				<FormControl fullWidth>
					<InputLabel>Entity Type</InputLabel>
					<Select
						value={filter.entityType ?? "All"}
						label="Entity Type"
						onChange={(event) =>
							onFilterChange({
								...filter,
								entityType: event.target.value as
									| EntityType
									| "All"
							})
						}
					>
						{entityTypeOptions.map((option) => (
							<MenuItem key={option} value={option}>
								{option}
							</MenuItem>
						))}
					</Select>
				</FormControl>
				<FormGroup row sx={{ alignItems: "center", gap: 2 }}>
					<Typography variant="subtitle2" sx={{ mb: 0, mr: 2 }}>
						Operation Types
					</Typography>
					{operationOptions.map((operation) => (
						<FormControlLabel
							key={operation}
							control={
								<Checkbox
									checked={
										filter.operations?.includes(
											operation
										) ?? false
									}
									onChange={(event) => {
										const selected =
											filter.operations ?? [];
										const next = event.target.checked
											? [...selected, operation]
											: selected.filter(
													(item) => item !== operation
												);
										onFilterChange({
											...filter,
											operations: next
										});
									}}
									name={operation}
								/>
							}
							label={operation}
						/>
					))}
				</FormGroup>
				<TextField
					label="User Email"
					value={filter.username ?? ""}
					onChange={(event) =>
						onFilterChange({
							...filter,
							username: event.target.value
						})
					}
					fullWidth
				/>
			</Box>
			<Box sx={{ mt: 2, display: "flex", gap: 2, flexWrap: "wrap" }}>
				<Button variant="contained" onClick={onApply}>
					Apply
				</Button>
				<Button variant="outlined" onClick={onReset}>
					Reset
				</Button>
			</Box>
		</Paper>
	);
};
